module.exports = __webpack_public_path__ + "static/media/logo.9f5ea421.png";